// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardheader {
  font-size: 32px;
  font-weight: 500px;
}
.accordion-button:not(.collapsed) {
  color: #242424;
}
.pad-mob0-desk12 {
  padding: 12px;
}
.marb-mob0-desk16 {
  margin-bottom: 16px;
}
.box_shadow {
  box-shadow: 1px 3px 10px 10px #0000000d;
}
.accordion-button {
  color: #242424;
  font-size: 12px;
  font-weight: 500;
}

.videodesc {
  padding: 0px 20px;
}

.checkb {
  box-sizing: border-box;
  box-shadow: inset 0px 0px 0px 2px #e31837;
  background-color: #fff;
  width: 15px;
  height: 15px;
  margin-left: 10px !important;
  margin-bottom: 10px;
  margin-top: 10px;
  position: absolute;
  z-index: 100;
}

.rolltitle {
  font-size: 14px;
  margin-bottom: 10px;
}

/* Hide Show Section start*/
main {
  display: block;
}

.expando {
  display: none;
}

.expando:target {
  display: block;
}
/* Hide Show Section end*/

.threedot {
  margin-left: 45px;
}

@media screen and (max-width: 999px) {
  .cardheader {
    font-size: 24px;
    font-weight: 500px;
  }
  .pad-mob0-desk12 {
    padding: 0px;
  }
  .marb-mob0-desk16 {
    margin-bottom: 0px;
  }
  .box_shadow {
    box-shadow: none;
  }
  .accordion-button {
    color: black;
    font-size: 16px;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/learning/Learning.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA,yBAAyB;;AAEzB;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".cardheader {\n  font-size: 32px;\n  font-weight: 500px;\n}\n.accordion-button:not(.collapsed) {\n  color: #242424;\n}\n.pad-mob0-desk12 {\n  padding: 12px;\n}\n.marb-mob0-desk16 {\n  margin-bottom: 16px;\n}\n.box_shadow {\n  box-shadow: 1px 3px 10px 10px #0000000d;\n}\n.accordion-button {\n  color: #242424;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.videodesc {\n  padding: 0px 20px;\n}\n\n.checkb {\n  box-sizing: border-box;\n  box-shadow: inset 0px 0px 0px 2px #e31837;\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  margin-left: 10px !important;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  position: absolute;\n  z-index: 100;\n}\n\n.rolltitle {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n/* Hide Show Section start*/\nmain {\n  display: block;\n}\n\n.expando {\n  display: none;\n}\n\n.expando:target {\n  display: block;\n}\n/* Hide Show Section end*/\n\n.threedot {\n  margin-left: 45px;\n}\n\n@media screen and (max-width: 999px) {\n  .cardheader {\n    font-size: 24px;\n    font-weight: 500px;\n  }\n  .pad-mob0-desk12 {\n    padding: 0px;\n  }\n  .marb-mob0-desk16 {\n    margin-bottom: 0px;\n  }\n  .box_shadow {\n    box-shadow: none;\n  }\n  .accordion-button {\n    color: black;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
